var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookpassicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C21.6241 0 26.1814 4.46289 26.1816 9.97461V13.2998H26.667C29.611 13.2998 32 15.6426 32 18.5254V32.7754C31.9998 35.6618 29.6147 38 26.667 38H5.33301C2.38881 37.9998 0.000216386 35.6579 0 32.7754V18.5254C0 15.6388 2.38513 13.2998 5.33301 13.2998H5.81836V9.97461C5.81857 4.46526 10.3759 2.52399e-07 16 0ZM5.33301 16.1504C5.01468 16.1501 4.69945 16.2109 4.40527 16.3301C4.11098 16.4493 3.84335 16.6241 3.61816 16.8447C3.39308 17.0652 3.21446 17.3271 3.09277 17.6152C2.97108 17.9036 2.9088 18.2134 2.90918 18.5254V32.7754C2.9094 34.0843 3.99641 35.1504 5.33301 35.1504H26.667C26.9853 35.1507 27.3005 35.0889 27.5947 34.9697C27.889 34.8505 28.1566 34.6757 28.3818 34.4551C28.6069 34.2345 28.7856 33.9728 28.9072 33.6846C29.0289 33.3964 29.0912 33.0873 29.0908 32.7754V18.5254C29.0908 17.2163 28.0037 16.1504 26.667 16.1504H5.33301ZM16 21C17.1046 21 18 21.8954 18 23V29C18 30.1046 17.1046 31 16 31C14.8954 31 14 30.1046 14 29V23C14 21.8954 14.8954 21 16 21ZM16 2.84961C11.9827 2.84961 8.72775 6.03941 8.72754 9.97461V13.2998H23.2725V9.97461C23.2722 6.03704 20.0178 2.84961 16 2.84961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookpassicon);
export default __webpack_public_path__ + "static/media/lookpassicon.63c6dc1014b72430ec6b1863718a1c5a.svg";
export { ForwardRef as ReactComponent };